import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [分享 banner 的列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=142296550
export const share_banner_list = createAsyncThunk(
  'ActivitySharing/share_banner_list',
  async (p: {to_mid: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'banner_list'>>
    >('/live/misc/share_banner_list', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export interface InitialStateType {
  banner_list?: {
    err_msg: string
    banner_id: number
    activity_url: string // 活动连接
    activity_name: string // 活动名字
    banner_img: string //	banner图片
  }[]
}

const initialState: InitialStateType = {
  banner_list: [],
}

export const ActivitySharingSlice = createSlice({
  name: 'ActivitySharing',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(share_banner_list.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {banner_list: data?.banner_list || []})
    })
  },
})

export const ActivitySharingAction = ActivitySharingSlice.actions
export default ActivitySharingSlice.reducer

export const useActivitySharingState = () => {
  const data = useSelector((state) => {
    return state.ActivitySharing
  })
  return data
}
